import { jsx, jsxs } from "react/jsx-runtime";
import { theme } from "../../../theme/index.js";
function SvgColor(props) {
    return /*#__PURE__*/ jsxs("svg", {
        width: "32",
        height: "32",
        viewBox: "0 0 32 32",
        fill: "none",
        ...props,
        children: [
            /*#__PURE__*/ jsx("path", {
                d: "M0 6C0 2.68629 2.68629 0 6 0H26C29.3137 0 32 2.68629 32 6V26C32 29.3137 29.3137 32 26 32H6C2.68629 32 0 29.3137 0 26V6Z",
                fill: theme.color["primary-700"]
            }),
            /*#__PURE__*/ jsx("path", {
                d: "M15 28V22.1266C15 19.2942 12.7618 17 10 17V22.8734C10 25.7058 12.2382 28 15 28Z",
                fill: theme.color.white
            }),
            /*#__PURE__*/ jsx("path", {
                d: "M13.5348 13.5524C14.435 12.655 15 11.4105 15 10.0349V9H10V15C11.3798 15 12.6281 14.4432 13.5348 13.5459V13.5524Z",
                fill: theme.color.white
            }),
            /*#__PURE__*/ jsx("path", {
                d: "M17 4V9.87339C17 12.7058 19.2382 15 22 15V9.12661C22 6.29419 19.7618 4 17 4Z",
                fill: theme.color.white
            }),
            /*#__PURE__*/ jsx("path", {
                d: "M18.4652 18.4476C17.565 19.345 17 20.5895 17 21.9651V23H22V17C20.6202 17 19.3719 17.5568 18.4652 18.4541V18.4476Z",
                fill: theme.color.white
            })
        ]
    });
}
export { SvgColor };
